import $ from 'jquery'
import { createAlert } from 'dom/window'
import _ from 'lodash'
import config from '../store/_config'
import { axiosInstance as axios, handleAxiosErrors, breakListIntoChunks } from '_utils'
import {
  convertProductMaintenanceDetailsToReact,
  convertProductMaintenanceDetailImagesToReact,
  convertProductMaintenanceDetailToPost,
  convertThreePlUpdateProductAvailabilityTypeToPost,
  convertOneAsnDetailToReact,
  mergePriceWithSingleProductDetail,
} from '../selectors/converterSelectors'
import {
  convertFrontlineProductsPricesToAReadableFormat,
  convertProductsListingToAReadableFormat,
  convertProductListingCategories,
  convertThreePlProductMaintenanceToAReadableFormat,
  filterCurrentAvailableProductsPrices,
  getModifiedPrice,
  getProductMaintainencePricePostData,
} from '../selectors/productSelectors'
import { requestCategoryNames, requestProductsByIDs, updateCategories } from './productsActions'
import { axiosRequestProductList, updateFullProductsList, updateProductsList } from './productsSupplierActions'
import { axiosUploadImages } from './imageActions'
import { param } from '../_utils'

export const toggleLoading = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_PRODUCT_MAINTENANCE_LOADING',
      key: key,
      value: value,
    })
  }
}

export const requestProductMaintenanceList = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    const params = {
      startingIndex: 0,
      perPage: 10000, //for fetching all records of search
      amount: 300,
      // WithSuperSupplierBrands: true,
    }

    dispatch(toggleLoading('list', true))

    return axiosRequestProductList(state, params)
      .then((response) => {
        if (typeof response?.data?.data?.searchResult != 'undefined') {
          const products = convertProductsListingToAReadableFormat(
            response?.data?.data?.searchResult?.edges,
            state.user
          )
          const categories = convertProductListingCategories(response?.data?.data?.searchResult?.edges, state.user) // NOTE: this was removed from the query on 18/12

          // Get product IDs to request price
          const productIDs = products.map((item) => item.id) // Uncomment this if you need to show price

          // wait for async requests
          Promise.all([
            dispatch(requestProductMaintenancePrices(productIDs)),
            dispatch(updateProductMaintenanceList(products)),
            // dispatch(requestThreePlProductsMaintenanceAvailabilities(productIDs)),
            //dispatch(updateCategories(categories)),
            // Joey commented it for testing
            // dispatch(requestProductsPrices(productIDs)), // Uncomment this if you need to show price
          ]).then((response) => {
            //dispatch(requestCategoryNames(Object.keys(categories)));
            dispatch(toggleLoading('list', false))
          })
        } else {
          dispatch(toggleLoading('list', false))
          createAlert({}, 'bad')
        }
      })
      .catch((error) => {
        dispatch(toggleLoading('list', false))
        console.log('error ======1111111', error)
        handleAxiosErrors(error)
      })
  }
}

export const updateProductMaintenancePrices = (modifiedRows) => {
  return (dispatch, getState) => {
    dispatch(toggleEditPriceButtonLoading(true))
    const state = getState()
    const getinputData = getProductMaintainencePricePostData(
      Object.values(state.productMaintenance?.compareProductPrices),
      modifiedRows
    )
    let { url, query } = config.products.createProductMaintenancePrice
    console.log('updateProductMaintenancePrices getinputData getProductMaintainencePricePostData', {
      getinputData,
      modifiedRows,
      compareProductPrices: state.productMaintenance?.compareProductPrices,
    })
    if (getinputData.length == 0) {
      dispatch(toggleEditPriceButtonLoading(false))
      return false
    }

    return axios
      .post(url, {
        query: query,
        variables: { Input: getinputData },
      })
      .then((response) => {
        // let availableProductsPrices = filterCurrentAvailableProductsPrices(
        //   response?.data?.data?.readProductMaintenancePrices,
        //   productIDs
        // )
        // dispatch(updateProductMaintenancePriceList(availableProductsPrices))
        dispatch(updateProductMaintenanceComparePriceList(Object.values(state.productMaintenance?.productPrices)))
        dispatch(toggleEditPriceButtonLoading(false))
      })
      .catch((error) => {
        dispatch(toggleEditPriceButtonLoading(false))
        handleAxiosErrors(error)
      })
  }
}

export const requestProductMaintenancePrices = (productIDs) => {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(toggleMaintenancePriceLoding(true))
    let { url, query } = config.products.readProductMaintenancePrices

    return axios
      .post(url, {
        query: query,
      })
      .then((response) => {
        let availableProductsPrices = filterCurrentAvailableProductsPrices(
          response?.data?.data?.readProductMaintenancePrices,
          productIDs
        )
        dispatch(updateProductMaintenancePriceList(availableProductsPrices))
        dispatch(updateProductMaintenanceComparePriceList(availableProductsPrices))
        dispatch(toggleMaintenancePriceLoding(false))
      })
      .catch((error) => {
        handleAxiosErrors(error)
        dispatch(toggleMaintenancePriceLoding(false))
      })
  }
}

export const SetProductAvailability = (ProductID, stockName, status) => {
  return (dispatch, getState) => {
    const state = getState()

    const updatedList = {
      [ProductID]: {
        id: ProductID,
        [stockName]: status,
      },
    }

    dispatch(updateProductMaintenanceList(updatedList))
    createAlert({ message: 'Product Availability Updated' }, 'success')
  }
}
export const addProductAvailability = (params) => {
  return (dispatch, getState) => {
    let { url, query } = config.threePlProductMaintenance.add
    const postData = convertThreePlUpdateProductAvailabilityTypeToPost({
      ...params,
    })

    return axios
      .post(url, {
        query: query,
        variables: {
          Input: postData,
        },
      })
      .then((response) => {
        if (response.data.data.updateSupplierProductAvailability) {
          dispatch(SetProductAvailability(params['productID'], params['name'], true))
          return true
        }
        createAlert({}, 'error')
        return false
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

export const removeProductAvailability = (params) => {
  return (dispatch, getState) => {
    let { url, query } = config.threePlProductMaintenance.add
    const postData = convertThreePlUpdateProductAvailabilityTypeToPost({
      ...params,
    })

    return axios
      .post(url, {
        query: query,
        variables: {
          Input: postData,
        },
      })
      .then((response) => {
        if (response.data.data.updateSupplierProductAvailability) {
          dispatch(SetProductAvailability(params['productID'], params['name'], false))
          return true
        }
        createAlert({}, 'error')
        return false
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

export const axiosRequestProcessedProductsMaitenanceAvailabilities = (chunkedProductIDs, memberID, zoneID = 0) => {
  let { url, query } = config.threePlProductMaintenance.readSupplierProductAvailabilities

  return axios.get(url, {
    withCredentials: true,
    params: {
      query,
    },
  })
}

export const requestThreePlProductsMaintenanceAvailabilities = (list) => {
  return (dispatch, getState) => {
    const chunkedList = breakListIntoChunks(list, 900)

    chunkedList.map((chunkedProductIDs) => {
      const state = getState()

      axiosRequestProcessedProductsMaitenanceAvailabilities(state, chunkedProductIDs)
        .then((response) => {
          const data = response.data.data.readSupplierProductAvailabilities.edges
          const products = convertThreePlProductMaintenanceToAReadableFormat(
            data,
            state.user,
            state.productMaintenance.list
          )
          dispatch(updateProductMaintenanceList(products))
        })
        .catch((error) => handleAxiosErrors(error))
    })
  }
}

export const requestProductsPrices = (list) => {
  return (dispatch, getState) => {
    const chunkedList = breakListIntoChunks(list, 900)

    chunkedList.map((chunkedProductIDs) => {
      const state = getState()

      axiosRequestFrontlineProductsPrices(state, chunkedProductIDs)
        .then((response) => {
          const { data } = response
          const products = convertFrontlineProductsPricesToAReadableFormat(
            data,
            state.user,
            state.productMaintenance.list
          )
          dispatch(updateProductMaintenanceList(products))
        })
        .catch((error) => handleAxiosErrors(error))
    })
  }
}

export const axiosRequestFrontlineProductsPrices = (state, chunkedProductIDs) => {
  const { key } = state.user

  let { url } = config.products.frontlinePricesSupplier
  url = url.replace('{productIDs}', chunkedProductIDs.join('_'))

  return axios
    .get(url, {
      withCredentials: true,
      headers: {
        Authorization: key,
      },
    })
    .catch((error) => handleAxiosErrors(error))
}

export const getDefaultProductMaintenanceDetails = (productID) => {
  return {
    isRemove: false,
    supplierProductNum: '',
    Name: '',
    productBrand: '',
    productDescription: '',
    size: '',
    splitPackSize: '',
    title: '',
    containerType: '',
    style: '',
    country: '',
    region: '',
    webCategory: '',
    varietals: '',
    abv: 0,
    coldStorage: false,
    package: '',
    unitsPerCase: 0,
    caseUPC: '',
    carrierUPC: '',
    unitUPC: '',
    productType: '',
    casePrice: 0,
    codeDateType: '',
    containerDepositLevy: 0,
    StockAvailableAdelaide: false,
    StockAvailableBrisbane: false,
    StockAvailableCairns: false,
    StockAvailableMelbourne: false,
    StockAvailableSydney: false,
    cartonWeight: 0,
    dimensionHeight: 0,
    dimensionWidth: 0,
    dimensionLength: 0,
    casesPerPallet: 0,
    casesPerLayer: 0,
    gstApplicable: false,
    wetApplicable: false,
    // levyNSW: 0,
    // levySA: 0,
    // levyQLD: 0,
    supplierid: 0,
    productid: productID,
    frontLinePrice: 0.0,
    // saDepositLevy: 0.0,
    images: [],
    removedImages: [],
    acceptedFiles: [],
    rejectedFiles: [],
    caseCostAdelaide: 0,
    caseCostBrisbane: 0,
    caseCostCairns: 0,
    caseCostMelbourne: 0,
    caseCostSydney: 0,
    PriceAdl: 0,
    PriceBris: 0,
    PriceCns: 0,
    PriceMel: 0,
    PriceSyd: 0,
    Status: '',
    Is3PLOnly: false,
    SellByCaseOnly: '0',
    HideOnWeb: false,
    MarketingTag: '',
    TrackVintages: false,
  }
}

export const getDefaultASNDetails = () => {
  return {
    dcLocation: '',
    supplierID: '',
    // stockBranchID: 0,
    referenceNumber: '',
    contactEmail: window.subSupplierParentEmail || '',
    freightSolution: 'Client to Organize',
    pickUpLocation: '',
    reqDateOfPickUp: '',
    dcDeliveryDate: '',
    description: '',
    addressLine1: '',
    addressLine2: '',
    suburb: '',
    postCode: '',
    locationPhone: '',
    locationEmail: '',
    // locationRunCode: '',
    // numberOfPhysicalPallets: 0,
    // numberOfEquivalentPallets: 0,
    loscamPallets: 0,
    chepPallets: 0,
    plainPallets: 0,
  }
}

export const loadProductMaintenanceDetails = (id) => {
  return (dispatch, getState) => {
    const state = getState()
    //const productMaintenanceModal = document.getElementById('edit-product-modal');
    dispatch(toggleEditProductDetailLoading(true))
    const productMaintenanceList = state.productMaintenance.list
    const productMaintenanceItem = productMaintenanceList[id]
    const productMaintenanceDetail = state.productMaintenance.detail
    let { productID, case_price, sku } = productMaintenanceItem

    const baseData = {
      productid: productID,
      supplierid: window.supplierID,
      paramountproductid: sku,
      frontLinePrice: case_price,
    }
    let { url, query } = config.productMaintenance.detail
    query = query.replace('{ProductID}', productID)

    if (!(productMaintenanceDetail && productMaintenanceDetail.productid == productID)) {
      dispatch(toggleLoading('modal', true))
      axios
        .get(url, {
          params: {
            query: query,
          },
        })
        .then((response) => {
          if (typeof response.data.data != 'undefined') {
            const list = convertProductMaintenanceDetailsToReact(response?.data?.data, baseData)

            let detail = list.length > 0 ? list.pop() : getDefaultProductMaintenanceDetails(id)

            // storing current Product Status on storage for disable product model
            if (detail && detail?.Status) {
              localStorage.setItem('currentProductStatus', detail?.Status)
            } else {
              localStorage.removeItem('currentProductStatus')
            }

            // update frontLinePrice
            if (detail.frontLinePrice <= 0) {
              detail.frontLinePrice = case_price
            }

            const productIDs = list.map((item) => item.id)

            dispatch(updateProductMaintenanceDetails(detail))
            // dispatch(toggleLoading('modal', false))

            requestSingleProductMaintenancePrice()
              .then((response) => {
                if (response?.data?.data?.readProductMaintenancePrices) {
                  let productWithPrice = mergePriceWithSingleProductDetail(
                    detail,
                    response?.data?.data?.readProductMaintenancePrices
                  )
                  dispatch(updateProductMaintenanceDetails(productWithPrice))
                }
                dispatch(toggleLoading('modal', false))
              })
              .catch((error) => {
                dispatch(toggleLoading('modal', false))
              })
          } else {
            if (typeof response.errors != 'undefined') {
              createAlert(response.errors[0], 'error')
            }

            console.log('Invalid response')
            //$(productMaintenanceModal).modal('hide');
          }
        })
        .catch((error) => handleAxiosErrors(error))
        .finally(() => {
          dispatch(toggleEditProductDetailLoading(false))
        })
    }
  }
}

export const loadProductMaintenanceDetailImages = () => {
  return (dispatch, getState) => {
    const state = getState()
    const productID = state.productMaintenance.detail.productID
    let { url, query } = config.productMaintenance.detailImages
    query = query.replace('{supplierID}', window.supplierID).replace('{productID}', productID)

    axios
      .get(url, {
        params: {
          query: query,
        },
        withCredentials: true,
      })
      .then((response) => {
        if (typeof response.data.data != 'undefined') {
          const list = convertProductMaintenanceDetailImagesToReact(response.data.data)

          if (list.length > 0) {
            const detail = list.pop()
            dispatch(updateProductMaintenanceDetails(detail))
          }
        } else {
          if (typeof response.errors != 'undefined') {
            createAlert(response.errors[0], 'error')
          }
        }
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

// Create post for product maintenance (add)
export const postProductMaintenance = (postData) => {
  return async (dispatch, getState) => {
    const ProductID = postData?.['productid'] ? parseInt(postData?.['productid'], 10) : 0
    const acceptedFiles = postData?.acceptedFiles

    dispatch(toggleLoading('form', true))
    //dispatch(toggleLoading(false));

    let images = []
    if (acceptedFiles?.length) {
      try {
        images = await Promise.all(
          acceptedFiles.map(async (file) => {
            return await axiosUploadImages(file)
          })
        )
      } catch (error) {
        dispatch(toggleLoading('form', false))
        return handleAxiosErrors(error)
      }
    }

    postData = convertProductMaintenanceDetailToPost({
      ...postData,
      images,
    })

    const { url, query } = config.productMaintenance.update
    try {
      const response = await axios.post(url, {
        query,
        variables: {
          ProductID,
          Input: postData,
        },
      })

      if (response?.data?.data?.createProductMaintenanceRequest) {
        // $('#edit-product-modal').modal('hide');
        // $('#add-product-modal').modal('hide');

        dispatch(requestProductMaintenanceList())
        dispatch(updateProductMaintenanceDetails({}))
        dispatch(resetProductMaintenanceDetails())

        createAlert(
          {
            message: 'Success',
          },
          'success'
        )
      } else {
        createAlert({}, 'error')
      }

      dispatch(toggleLoading('form', false))
    } catch (error) {
      dispatch(toggleLoading('form', false))
      return handleAxiosErrors(error)
    }
  }
}

export const removeProductMaintenanceImage = (id, imageID) => {
  return (dispatch, getState) => {
    let { url } = config.productMaintenance.removeImage

    if (id && imageID) {
      axios
        .get(url, {
          params: {
            id: id,
            imageid: imageID,
          },
          withCredentials: true,
        })
        .then((response) => {
          //dispatch(toggleLoading(false));
          const { data } = response

          if (typeof data.status != 'undefined' && data.status) {
            dispatch(loadProductMaintenanceDetailImages())

            if (typeof data.message != 'undefined') {
              createAlert(data, 'success')
            }
          } else {
            createAlert({}, 'error')
          }
        })
        .catch((error) => handleAxiosErrors(error))
    }
  }
}

export const updateProductMaintenanceList = (list) => {
  return {
    type: 'UPDATE_PRODUCT_MAINTENANCE_LIST',
    list: _.keyBy(list, 'id'),
  }
}

export const toggleAsnButtonLoading = (value) => {
  return {
    type: 'TOGGLE_ASB_BUTTON_LOADING',
    value: value,
  }
}

export const toggleAsnDeleteButtonLoading = (value) => {
  return {
    type: 'TOGGLE_ASB_DELETE_BUTTON_LOADING',
    value: value,
  }
}

export const updateProductMaintenancePriceList = (list) => {
  return {
    type: 'UPDATE_PRODUCT_MAINTENANCE_PRICE_LIST',
    list: _.keyBy(list, 'BuyableID'),
  }
}

export const updateProductMaintenanceLocationPrice = (row, key, value) => {
  return (dispatch, getState) => {
    if (value !== '' && isNaN(value)) {
      return false
    }
    dispatch({
      type: 'UPDATE_PRODUCT_MAINTENANCE_LOCATION_PRICE',
      id: row?.original?.id,
      value: { key, value },
    })
  }
}

export const toggleMaintenancePriceLoding = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_MAINTENANCE_PRICE_LOADING',
      value: value,
    })
  }
}

export const toggleEditPriceButtonLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_EDIT_PRICE_BUTTON_LOADING',
      value: value,
    })
  }
}

export const updateProductMaintenanceComparePriceList = (list) => {
  return {
    type: 'UPDATE_PRODUCT_MAINTENANCE_COMPARE_PRICE_LIST',
    list: _.keyBy(list, 'BuyableID'),
  }
}

export const updateProductMaintenanceDetails = (detail) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_PRODUCT_MAINTENANCE_DETAIL',
      detail: detail,
    })

    if (detail.netInvoicePrice == 0) {
      dispatch(adjustInvoiceAllowance('invoiceAllowance', 'edit'))
    }
  }
}

export const updateAsnDetails = (row, key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_ADVANCE_SHIPPING_DETAILS',
      row: row,
      key: key,
      value: Number(value),
    })
  }
}

export const updateAsnItems = (list) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_ADVANCE_SHIPPING_NOTICE_ITEMS',
      value: list,
    })
  }
}

export const changeThreePlASNForm = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHANGE_THREE_PL_ASN_FORM',
      key: key,
      value: value,
    })
  }
}

export const changeThreePlASNEditForm = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHANGE_THREE_PL_ASN_EDIT_DETAIL',
      key: key,
      value: value,
    })
  }
}

export const resetThreePlASNForm = () => {
  return (dispatch, getState) => {
    dispatch({
      type: 'RESET_THREE_PL_ASN_FORM',
    })
  }
}

export const changeProductMaintenanceDetails = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHANGE_PRODUCT_MAINTENANCE_DETAIL',
      key: key,
      value: value,
    })

    dispatch(adjustInvoiceAllowance(key, 'edit'))
  }
}

export const changeProductMaintenanceDetailsBulk = (values) => {
  return {
    type: 'CHANGE_PRODUCT_MAINTENANCE_DETAIL_BULK',
    values: values,
  }
}

export const changeProductMaintenanceAddDetails = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHANGE_PRODUCT_MAINTENANCE_NEW_FORM',
      key: key,
      value: value,
    })

    dispatch(adjustInvoiceAllowance(key, 'add'))
  }
}

export const changeProductMaintenanceAddDetailsBulk = (values) => {
  return {
    type: 'CHANGE_PRODUCT_MAINTENANCE_NEW_FORM_BULK',
    values: values,
  }
}

export const resetProductMaintenanceDetails = (values) => {
  return {
    type: 'RESET_PRODUCT_MAINTENANCE_NEW_FORM_BULK',
    values: values,
  }
}

export const updateAsnPickupLocations = (list) => {
  return {
    type: 'UPDATE_ASN_PICKUP_LOCATION',
    value: list,
  }
}

export const updateOneAsnDetail = (value) => {
  return {
    type: 'UPDATE_THREE_PL_ASN_DETAIL',
    value: value,
  }
}

export const requestEditAsnDetail = (ID) => {
  return async (dispatch, getState) => {
    const state = getState()
    const { url, query } = config.advancedShippingNotice.readOneAdvancedShippingNotice
    try {
      const response = await axios.post(url, {
        query,
        variables: {
          ID: Number(ID),
        },
      })
      if (response?.data?.data?.readOneAdvancedShippingNotice) {
        let asnData = convertOneAsnDetailToReact(response?.data?.data?.readOneAdvancedShippingNotice)
        dispatch(updateOneAsnDetail(asnData))

        //Set ASN Items
        const { AdvancedShippingNoticeItems } = response?.data?.data?.readOneAdvancedShippingNotice
        if (AdvancedShippingNoticeItems?.edges?.length > 0) {
          let filteredAsnItems = AdvancedShippingNoticeItems?.edges?.filter((item) => item?.node?.Product?.ID != '0')
          let asnItems = []
          let productList = []
          asnItems = filteredAsnItems?.map((item, index) => {
            const node = item.node
            return {
              Carton: node?.Carton,
              ProductID: node?.Product?.ID,
              // CartonReceived: node?.CartonReceived
              // Weight: node?.Weight,
            }
          })
          dispatch(updateAsnItems(asnItems))
        }
      }
    } catch (error) {
      return handleAxiosErrors(error)
    }
  }
}

export const requestOneAsnDetail = (ID) => {
  return async (dispatch, getState) => {
    const state = getState()
    const { url, query } = config.advancedShippingNotice.readOneAdvancedShippingNotice
    try {
      const response = await axios.post(url, {
        query,
        variables: {
          ID: Number(ID),
        },
      })
      if (response?.data?.data?.readOneAdvancedShippingNotice) {
        let asnData = convertOneAsnDetailToReact(response?.data?.data?.readOneAdvancedShippingNotice)
        dispatch(updateOneAsnDetail(asnData))

        //Set ASN Items
        const { AdvancedShippingNoticeItems } = response?.data?.data?.readOneAdvancedShippingNotice
        if (AdvancedShippingNoticeItems?.edges?.length > 0) {
          let filteredAsnItems = AdvancedShippingNoticeItems?.edges?.filter((item) => item?.node?.Product?.ID != '0')
          let asnItems = []
          let productList = []
          asnItems = filteredAsnItems?.map((item, index) => {
            const node = item.node
            return {
              Carton: node?.Carton,
              ProductID: node?.Product?.ID,
              CartonReceived: node?.CartonReceived,
              // Weight: node?.Weight,
            }
          })
          productList = filteredAsnItems?.map((item, i) => {
            const node = item?.node?.Product

            return { node }
          })
          // productList
          const products = convertProductsListingToAReadableFormat(productList, state.user)
          // console.log('AdvancedShippingNoticeItems?.edges', { edges: AdvancedShippingNoticeItems?.edges, filteredAsnItems, products, productList, asnItems })
          dispatch(updateFullProductsList(products))
          dispatch(updateProductsList(products, products?.length))
          dispatch(updateAsnItems(asnItems))
        }
      }
    } catch (error) {
      return handleAxiosErrors(error)
    }
  }
}

export const readAsnPickupLocations = (ID) => {
  return async (dispatch, getState) => {
    const { url, query } = config.advancedShippingNotice.readAsnPickupLocations
    dispatch(updateAsnPickupLocations([]))
    console.log(ID, 'sublime postData readAsnPickupLocations')
    try {
      const response = await axios.post(url, {
        query,
        variables: {
          LocationID: Number(ID),
        },
      })
      if (response?.data?.data?.readSupplierLocation?.length > 0) {
        dispatch(updateAsnPickupLocations(response?.data?.data?.readSupplierLocation))
      }
    } catch (error) {
      return handleAxiosErrors(error)
    }
  }
}

export const submitThreePlASNForm = (postData) => {
  return async (dispatch, getState) => {
    const { url, query } = config.advancedShippingNotice.createShippingNotice
    dispatch(toggleAsnButtonLoading(true))
    console.log(postData, 'postData submitThreePlASNForm')
    try {
      const response = await axios.post(url, {
        query,
        variables: {
          Input: postData,
        },
      })
      if (response?.data?.data) {
        dispatch(toggleAsnButtonLoading(false))
        window.location.href = '/supplier/advance-shipping-notice'
        createAlert(
          {
            message: 'Success',
          },
          'success'
        )
      } else {
        createAlert({}, 'error')
      }
    } catch (error) {
      dispatch(toggleAsnButtonLoading(false))
      return handleAxiosErrors(error)
    }
  }
}

export const deleteThreePlASN = (params) => {
  return async (dispatch, getState) => {
    const { url, query } = config.advancedShippingNotice.deleteShippingNotice
    dispatch(toggleAsnDeleteButtonLoading(true))

    console.log(params, 'postData deleteThreePlASN')
    try {
      const response = await axios.post(url, {
        query,
        variables: {
          ...params,
        },
      })
      if (response?.data?.data) {
        dispatch(toggleAsnDeleteButtonLoading(false))
        window.location.href = '/supplier/advance-shipping-notice'
        createAlert(
          {
            message: 'Success',
          },
          'success'
        )
      } else {
        createAlert({}, 'error')
      }
    } catch (error) {
      dispatch(toggleAsnDeleteButtonLoading(false))
      return handleAxiosErrors(error)
    }
  }
}

export const adjustInvoiceAllowance = (key, type) => {
  return (dispatch, getState) => {
    if (key == 'invoiceAllowance' || key == 'invoiceAllowanceType' || key == 'frontLinePrice') {
      const isEdit = typeof type != 'undefined' && type == 'edit'
      const state = getState()
      const detail = isEdit ? state.productMaintenance.detail : state.productMaintenance.newForm
      const { invoiceAllowanceType, frontLinePrice } = detail
      let { invoiceAllowance } = detail

      let calculatedNetInvoicePrice = frontLinePrice

      // Check min
      if (invoiceAllowance < 0) {
        invoiceAllowance = 0
      }

      // Check depending on value
      if (invoiceAllowanceType == 'Amount') {
        // Check max for fixed
        if (invoiceAllowance > frontLinePrice) {
          invoiceAllowance = frontLinePrice
        }

        calculatedNetInvoicePrice = frontLinePrice - invoiceAllowance
      } else {
        // Check max for percentage
        if (invoiceAllowance > 100) {
          invoiceAllowance = 100
        }

        calculatedNetInvoicePrice = frontLinePrice - (frontLinePrice * invoiceAllowance) / 100
      }

      // Rounding
      calculatedNetInvoicePrice = Math.round(calculatedNetInvoicePrice * 100) / 100

      // And update
      if (isEdit) {
        dispatch(
          changeProductMaintenanceDetailsBulk({
            invoiceAllowance: invoiceAllowance,
            netInvoicePrice: calculatedNetInvoicePrice,
          })
        )
      } else {
        dispatch(
          changeProductMaintenanceAddDetailsBulk({
            invoiceAllowance: invoiceAllowance,
            netInvoicePrice: calculatedNetInvoicePrice,
          })
        )
      }
    }
  }
}

export const requestSingleProductMaintenancePrice = () => {
  let { url, query } = config.products.readProductMaintenancePrices

  return axios.post(url, {
    query: query,
  })
}

export const toggleEditProductDetailLoading = (value) => {
  return {
    type: 'TOGGLE_EDIT_PRODUCT_DETAIL_LOADING',
    value: value,
  }
}
